export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9802.39a520ec.jpg";